<div class="modal-content">
  @if (status)
  {
    <organization-form
      [status]="status"
      [data]="item"
      (processCompleted)="onProcessCompleted($event)"></organization-form>
  }
</div>
